import { createStyles } from 'antd-style';

export const useStatinoStyles = createStyles(({ token, css, cx }, { readonly }: { readonly: boolean }) => {
  const gap = 10;

  const center = cx(
    css({
      flex: '1 0 auto',
      position: 'relative',
      padding: readonly ? `${gap}px 0` : `${gap}px`,
    })
  );
  return {
    center,
    container: css`
      background: ${token.colorBgContainer};
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      flex: 1;
      border-radius: ${token.borderRadiusLG}px;
    `,
    head: css({
      textAlign: 'center',
      padding: '7px 0',
      borderBottom: `1px dashed ${token.colorBorderSecondary}`,
      position: 'relative',
      marginBottom: '0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
    headCenter: css({ flex: '1' }),
    headActions: css({ marginLeft: 'auto', justifySelf: 'flex-end', paddingRight: '10px' }),
    itemWrapper: css({
      display: 'flex',
      flexDirection: 'column',
      gap,
    }),
    pos: css({
      [`.${center}`]: {
        overflow: 'auto',
        height: 1,
      },
    }),
  };
});
